<script lang="ts" setup>
import { ref, inject } from 'vue';
import { SERVICE_TAB_LIST } from '@@summit/2023/constants';
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue';
import { marked } from 'marked';
import SliceImage from '@@summit/2023/components/SliceImage.vue';
import dayjs from 'dayjs';

defineOptions({
  name: 'PageHomeAgenda',
});

const { resizeComponent } = inject<any>('floatNavigator');
const servicetabList = ref<any>(SERVICE_TAB_LIST);
const dayDiff = dayjs().diff('2023-06-11', 'day');
const defaultIndex = dayDiff < 0 || dayDiff > 2 ? 0 : dayDiff;

const resize = () => {
  resizeComponent();
};

const getMarkedContent = ((content: string) => {
  return content ? marked.parse(content) : '';
});

const normalize = (str: string) => {
  return str.replace(/：/g, ':').replace(/~/g, '-');
}
</script>

<template>
  <section class="page-home-agenda" @click="resize">
    <h2 class="mt-[128px] text-32px text-#00479D font-medium leading-45px">峰会议程</h2>
    <p class="mt-4px text-14px text-#00479D font-normal leading-20px">AGENDA</p>
    <div class="openatom-servicec mt-[32px]">
      <div class="openatom-service-tab">
        <TabGroup :default-index="defaultIndex">
          <TabList class="tablist relative flex" v-slot="{ selectedIndex }">
            <div class="absolute underline">
            </div>
            <div class="underline-bottom absolute" :style="{ left: `${(0 + selectedIndex * 120)}px` }"></div>
            <Tab
              v-for="item in servicetabList"
              :key="item.title"
              as="template"
              v-slot="{ selected }"
            >
              <div
                :class="[
                  'tablist-btn',
                  selected
                    ? 'selected'
                    : ''
                ]"
              >
                {{ item.title }}
              </div>
            </Tab>
          </TabList>
          <TabPanels class="tabpannels">
            <TabPanel
              v-for="(item) in servicetabList"
              :key="item.title"
              class="tabpanel"
            >
              <div class="tabpanel-list w-[1200px] flex flex-nowrap">
                <div class="mt-[16px] w-[160px] flex-shrink-0">
                  <p class="tabpanel-list-date">{{ item.day }}</p>
                  <p class="tabpanel-list-conferencehall mt[-24px]">{{ item.host }}</p>
                  <p class="tabpanel-list-report">{{ item.report }}</p>
                </div>
                <div>
                  <div class="card-description" v-for="(piece, index) in item.content" :key="index">
                    <p class="mt-24px text-12px text-#747678 font-normal leading-24px">{{ normalize(piece.time) }}</p>
                    <div class="flex flex-nowrap">
                      <h4 class="m-0">{{ piece.title }}</h4>
                      <div class="h-[36px] flex shrink-0 cursor-pointer items-center justify-around" @click="piece.state = !piece.state" v-if="piece.content">
                        <span class="learn-more ml-[18px]">了解更多详情</span>
                        <img :class="{ 'rotate-90': piece.state }" src="@normal/summit/2023/assets/arrow-down.svg" alt="" class="h-[12px] w-[12px] align-middle transition-all">
                      </div>
                    </div>
                    <Transition name="collapse">
                      <div v-if="piece.state">
                        <p class="card-description-content mb-[16px] mt-[16px]" :class="{ 'card-description-piece-content': piece.content == '' }">{{ piece.content }}</p>
                        <h3 class="card-description-schedule mt-16px">{{ piece.schedule }}</h3>
                        <div class="mt-8px flex" v-for="(piece1, index2) in piece.scheduleList" :key="index2">
                          <p class="card-description-content-time flex-shrink-0">{{ normalize(piece1.time) }}</p>
                          <div class="card-description-content-content flex flex-col justify-evenly">
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <div v-for="(piece3, index5) in piece1.content" :key="index5" class="text-14px font-medium" v-html="getMarkedContent(piece3)"></div>
                          </div>
                        </div>
                        <h3 class="card-description-schedule mt-16px">{{ piece.guest }}</h3>
                        <div class="flex flex-wrap">
                          <SliceImage class="mr-16px mt-8px" :url="piece.peopleImage" width="176" height="200" v-slot="{ image, index: inx }">
                            <div :class="{ 'producer': inx < piece.producerCounts }" class="h-full w-full">
                              <img class="card-description-image" :src="image" alt="">
                            </div>
                          </SliceImage>
                        </div>
                      </div>
                    </Transition>
                    <p class="card-description-speaker">{{ piece.speaker }}</p>
                    <div class="card-description-underline mt-[24px]">
                    </div>
                  </div>
                </div>
              </div>
              <div class="tabpanel-list mt-[48px] w-[1200px] flex flex-nowrap" v-for="(item1, index) in item.branch" :key="index">
                <div class="mt-[16px] w-[160px] flex-shrink-0">
                  <p class="tabpanel-list-date">{{ item1.day }}</p>
                  <p class="tabpanel-list-conferencehall mt[-24px]">{{ item1.divide }}</p>
                  <p class="tabpanel-list-report">{{ item1.report }}</p>
                </div>
                <div>
                  <div class="card-description" v-for="(item2, index1) in item1.content" :key="index1">
                    <p class="mt-24px text-12px text-#747678 font-normal leading-24px">{{ normalize(item2.time) }}</p>
                    <div class="flex flex-nowrap">
                      <h4 class="m-0">{{ item2.title }}</h4>
                      <div class="h-[36px] flex shrink-0 cursor-pointer items-center justify-around" @click="item2.state = !item2.state" v-if="item2.content">
                        <span class="learn-more ml-[18px]">了解主题详情</span>
                        <img :class="{ 'rotate-90': item2.state }" src="@normal/summit/2023/assets/arrow-down.svg" alt="" class="h-[12px] w-[12px] align-middle transition-all">
                      </div>
                    </div>

                    <Transition name="collapse">
                      <div v-if="item2.state">
                        <p class="card-description-content mb-[16px] mt-[16px]" :class="{ 'card-description-piece-content': item2.content == '' }">{{ item2.content }}</p>
                        <h3 class="card-description-schedule mt-16px">{{ item2.schedule }}</h3>
                        <div class="mt-8px flex" v-for="(item3, index3) in item2.scheduleList" :key="index3">
                          <p class="card-description-content-time flex-shrink-0">{{ normalize(item3.time) }}</p>
                          <div class="card-description-content-content flex flex-col justify-evenly">
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <div v-for="(piece3, index5) in item3.content" :key="index5" class="text-14px font-medium" v-html="getMarkedContent(piece3)"></div>
                          </div>
                        </div>
                        <h3 class="card-description-schedule mt-16px">{{ item2.guest }}</h3>
                        <div class="flex flex-wrap">
                          <SliceImage class="mr-16px mt-8px" :url="item2.peopleImage" width="176" height="200" v-slot="{ image, index: inx }">
                            <div :class="{ 'producer': inx < item2.producerCounts }" class="h-full w-full">
                              <img class="card-description-image" :src="image" alt="">
                            </div>
                          </SliceImage>
                        </div>
                      </div>
                    </Transition>

                    <p class="card-description-speaker">{{ item2.speaker }}</p>
                    <div class="card-description-underline mt-[24px]">
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-home-agenda {
  width: 1200px;
  margin: 0 auto;

  .collapse-enter-active,
  .collapse-leave-active {
    transition: opacity 0.3s;
  }

  .collapse-enter-from,
  .collapse-leave-to {
    opacity: 0;
  }

  *:focus-visible {
    outline: none;
  }

  .tablist {
    justify-content: left;
    width: 1200px;
  }

  .card-description-piece-content {
    margin: 0;
  }

  .tablist-btn {
    width: 120px;
    color: rgb(45, 45, 45);
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    text-align: center;
    cursor: pointer;

    &:focus-visible {
      outline: unset;
    }

    // &.selected {
    //   color: #1180ff;
    // }
  }

  .underline {
    position: absolute;
    bottom: 0;
    width: 1200px;
    height: 1px;
    background: linear-gradient(86.57deg, rgba(25, 51, 143, 1) -0.097%, rgba(32, 144, 204, 1) 48.999%, rgba(128, 196, 141, 1) 100.098%) !important;
    opacity: 0.1;
  }

  .underline-bottom {
    position: absolute;
    top: 30px;
    left: 0;
    width: 120px;
    height: 2px;
    background: linear-gradient(86.57deg, rgba(25, 51, 143, 1) -0.097%, rgba(32, 144, 204, 1) 48.999%, rgba(128, 196, 141, 1) 100.098%);
    transition: left .3s;
  }

  .card-description:last-child {
    .card-description-underline {
      display: none;
    }
  }

  .card-description {
    width: 1040px;

    h4 {
      display: flex;
      align-items: center;
      color: rgb(45, 45, 45);
      font-weight: 400;
      font-size: 24px;
      line-height: 36px;
      text-align: left;
    }

    .learn-more {
      color: rgb(0, 71, 157);
      font-weight: 400;
      font-size: 12px;
      text-align: center;
    }

    .card-description-content {
      width: 1040px;
      color: rgb(116, 118, 120);
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: left;
    }

    .card-description-speaker {
      color: rgb(116, 118, 120);
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      text-align: left;
    }

    .card-description-underline {
      width: 1040px;
      height: 1px;
      background: linear-gradient(90deg, rgba(25, 51, 143, 1) -0.098%, rgba(32, 144, 204, 1) 48.999%, rgba(128, 196, 141, 1) 100.099%);
      opacity: 0.1;
    }
  }

  .tabpanel-list {
    .tabpanel-list-date {
      font-weight: 100;
      font-size: 32px;
      line-height: 48px;
      background: linear-gradient(180deg, rgba(0, 71, 157, 1) 0%, rgba(0, 71, 157, 0) 100%);
      -webkit-background-clip: text;
      background-clip: text;
      opacity: 0.5;
      -webkit-text-fill-color: transparent;
    }

    .tabpanel-list-conferencehall {
      font-weight: 500;
      font-size: 32px;
      line-height: 48px;
      text-align: left;
      background: linear-gradient(93.6deg, rgba(25, 51, 143, 1) 0%, rgba(32, 144, 204, 1) 49%, rgba(128, 196, 141, 1) 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      opacity: 1;
    }

    .tabpanel-list-report {
      width: 100px;
      margin-left: 4px;
      color: #00479d;
      font-size: 12px;
      line-height: 16px;
    }
  }

  .card-description-content-content {
    color: rgb(116, 118, 120);
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: left;

    &::v-deep() {
      p {
        white-space: pre-wrap;
      }
    }
  }

  .card-description-schedule {
    color: rgb(45, 45, 45);
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
  }

  .card-description-image {
    width: 176px;
    height: 200px;
  }

  .card-description-content-time {
    width: 96px;
    color: rgb(116, 118, 120);
    font-weight: 400;
    font-size: 14px !important;
    line-height: 24px;
    text-align: left;
  }
}
</style>
